// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605110017/js/" + chunkId + "." + {"44":"be3152df","225":"52223e28","481":"06c88512","486":"21c85c4d","770":"1ef3b769"}[chunkId] + ".0.17576730728830992.chunk.js";
};